__turbopack_context__.v({
  "products": "_3PATKa_products",
  "soldOutWrapper": "_3PATKa_soldOutWrapper",
  "userDetailsAnchor": "_3PATKa_userDetailsAnchor",
  "wrapper": "_3PATKa_wrapper",
});
